import { createFileRoute, notFound } from '@tanstack/react-router';
import { SellerPage } from '../../../pages/sellers/SellerPage';
import { ensureCatalogEntries } from '../../../features/catalog/queries';
import { loadSeller } from '../../../features/sellers/queries';
import { staticPageHead } from '../../../lib/seo/staticPageHead';

export const Route = createFileRoute('/_site/sellers/$slug')({
  // Resolved before the page renders so a crawler or a reader with no
  // JavaScript gets the seller. The page renders per request, never
  // prerendered (scripts/prerenderScope.ts RUNTIME_PREFIXES), so it is live. A
  // slug no listed seller has is a 404; an unreachable gateway renders the
  // page's unavailable state instead.
  loader: async ({ context, params }) => {
    const [, seller] = await Promise.all([
      ensureCatalogEntries(context.queryClient),
      loadSeller(context.queryClient, params.slug),
    ]);
    if (seller === null) throw notFound();
    return seller;
  },
  head: ({ params, loaderData }) =>
    staticPageHead({
      path: `/sellers/${params.slug}`,
      title: loaderData ? `${loaderData.name} - Marketplace Seller - AnyAPI` : 'Marketplace Seller - AnyAPI',
      description: loaderData
        ? `${loaderData.name} sells data APIs on AnyAPI. See who they are and the endpoints they serve.`
        : 'A marketplace seller on AnyAPI and the endpoints it serves.',
      crumb: loaderData?.name ?? 'Marketplace seller',
      // Out of search results like the list (sellers/index.tsx).
      robots: 'noindex, follow',
    }),
  component: SellerRoute,
});

function SellerRoute() {
  const { slug } = Route.useParams();
  return <SellerPage slug={slug} initialSeller={Route.useLoaderData()} />;
}
